<div class="notify notify_{{greeting.type}}">
  <app-icon class="notify__icon" file="greetings" [icon]="params.icon"></app-icon>

 <div class="notify__text bold" [innerHTML]="params.title | translate: {
     'user': ('<div>' + greeting.username + '</div>')
  }"></div>
</div>
